"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconBookmarkFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconBookmarkFilled = function SvgIconBookmarkFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 1.5C1 0.947715 1.44772 0.5 2 0.5H10C10.5523 0.5 11 0.947715 11 1.5V10.4194C11 11.2579 10.0301 11.7241 9.37531 11.2002L6.6247 8.99976C6.25948 8.70758 5.74052 8.70758 5.37531 8.99976L2.6247 11.2002C1.96993 11.7241 1 11.2579 1 10.4194V1.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }))));
};

exports.SvgIconBookmarkFilled = SvgIconBookmarkFilled;